// extracted by mini-css-extract-plugin
export default {"container":"BpsAdminHeader_container__Xe9Jf","menuButton":"BpsAdminHeader_menuButton__Or1zZ"};